module.exports = __webpack_public_path__ + "static/media/Board_3@2x.3be7f970.png";